// hooks
import { Fragment, useCallback, useEffect, useState } from "react";
import useHttp from "hooks/use-http";

// routes
import { useParams } from "react-router-dom";

// material style
import { Grid } from "@mui/material";

// components
import LoadingCM from "components/shared/Loading";
import DrawerCM from "components/shared/Drawer";
import BackButton from "components/shared/BackButton";

// styled components
import {
  StyledStack,
  StyledTitle,
  StyledUserTitle,
  StyledUserName,
} from "./messageDetail.style";

// request methods
import { getUsersMessageByIdRequest } from "api/requests/messages";

export default function MessageDetails() {
  const { message_id } = useParams();

  const { request, loading, setLoading } = useHttp(false);

  // message details by id state
  const [messageInfo, setMessageInfo] = useState({ data: [], count: 0 });

  // message jallali date state
  const [jDate, setJDate] = useState("");

  // get message info by id method
  const getMessageInfo = useCallback(async () => {
    setLoading(true);
    const res = await request({
      url: getUsersMessageByIdRequest,
      values: { id: message_id },
    });

    if (res) {
      if (res.data.length < 1) {
        return setMessageInfo({
          count: res.data.length,
          data: [{ content: "هیچ اطلاعاتی یافت نشد" }],
        });
      }
      setMessageInfo(res.data);
      setJDate(res.data.created_at.jdate.split(" ")[0]);
    }
  }, [request]);

  useEffect(() => {
    getMessageInfo();
  }, [getMessageInfo]);

  return (
    <DrawerCM title="نمایش پیام">
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <Grid container>
            <Grid item mt={3} xs={12}>
              <BackButton Route="/messages" />
            </Grid>
            <StyledStack>
              <StyledTitle>نمایش اطلاعات پیام</StyledTitle>
              <Grid container>
                <Grid item md={6} xs={12} p={1.5}>
                  <StyledUserTitle>نام و نام خانوادگی کاربر:</StyledUserTitle>
                  <StyledUserName>{messageInfo.full_name}</StyledUserName>
                </Grid>
                {/* <Grid item md={4} xs={12} p={1.5}>
                  <StyledUserTitle>عنوان:</StyledUserTitle>
                  <StyledUserName>{messageInfo.title ? messageInfo.title : 'عنوانی ثبت نشده است'}</StyledUserName>
                </Grid> */}
                <Grid item md={6} xs={12} p={1.5}>
                  <StyledUserTitle>تاریخ:</StyledUserTitle>
                  <StyledUserName>{jDate}</StyledUserName>
                </Grid>
                <Grid item md={6} xs={12} p={1.5}>
                  <StyledUserTitle>ایمیل:</StyledUserTitle>
                  <StyledUserName>{messageInfo.email}</StyledUserName>
                </Grid>
                <Grid item md={6} xs={12} p={1.5}>
                  <StyledUserTitle>شماره تماس:</StyledUserTitle>
                  <StyledUserName>{messageInfo.phone_number}</StyledUserName>
                </Grid>
                <Grid item xs={12} p={1.5}>
                  <StyledUserTitle>شرح درخواست:</StyledUserTitle>
                  <StyledUserName>{messageInfo.message}</StyledUserName>
                </Grid>
              </Grid>
            </StyledStack>
          </Grid>
        </Fragment>
      )}
    </DrawerCM>
  );
}
